import React from 'react';
import { Instagram, Facebook, MapPin, MessageCircle, Clock } from 'lucide-react';
interface FooterProps {
  onOpenPrivacy: () => void;
  onOpenTerms: () => void;
}
export function Footer({
  onOpenPrivacy,
  onOpenTerms
}: FooterProps) {
  return <footer className="bg-mystic-black border-t border-mystic-gold/10 pt-16 pb-8 px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-87">
      <div className="max-w-7xl mx-auto" data-id="element-88">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-89">
          {/* Brand & Info */}
          <div className="lg:col-span-2" data-id="element-90">
            <h3 className="text-2xl font-serif font-bold text-mystic-gold mb-4" data-id="element-91">
              Maestro Navy
            </h3>
            <p className="text-mystic-white/70 font-light max-w-md leading-relaxed mb-6" data-id="element-92">
              Guía espiritual y terapeuta energético dedicado a brindar
              claridad, equilibrio y bienestar a través de métodos profesionales
              y confidenciales.
            </p>
            <div className="flex gap-4" data-id="element-93">
              <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-mystic-blue-900/50 border border-mystic-gold/20 flex items-center justify-center text-mystic-white hover:text-mystic-gold hover:border-mystic-gold/50 transition-colors" data-id="element-94">
                <Instagram className="w-5 h-5" data-id="element-95" />
              </a>
              <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-mystic-blue-900/50 border border-mystic-gold/20 flex items-center justify-center text-mystic-white hover:text-mystic-gold hover:border-mystic-gold/50 transition-colors" data-id="element-96">
                <Facebook className="w-5 h-5" data-id="element-97" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-98">
            <h4 className="text-lg font-serif font-semibold text-mystic-white mb-4" data-id="element-99">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-100">
              <li className="flex items-start gap-3 text-mystic-white/70" data-id="element-101">
                <MapPin className="w-5 h-5 text-mystic-gold shrink-0 mt-0.5" data-id="element-102" />
                <span className="font-light" data-id="element-103">
                  Atención presencial en
                  <br data-id="element-104" />
                  Antofagasta, Chile
                </span>
              </li>
              <li className="flex items-center gap-3 text-mystic-white/70" data-id="element-105">
                <MessageCircle className="w-5 h-5 text-mystic-gold shrink-0" data-id="element-106" />
                <a href="https://wa.link/lvbw8v" target="_blank" rel="noopener noreferrer" className="font-light hover:text-mystic-gold transition-colors" data-id="element-107">
                  Escríbeme por WhatsApp
                </a>
              </li>
            </ul>
          </div>

          {/* Schedule */}
          <div data-id="element-108">
            <h4 className="text-lg font-serif font-semibold text-mystic-white mb-4" data-id="element-109">
              Horario
            </h4>
            <ul className="space-y-4" data-id="element-110">
              <li className="flex items-start gap-3 text-mystic-white/70" data-id="element-111">
                <Clock className="w-5 h-5 text-mystic-gold shrink-0 mt-0.5" data-id="element-112" />
                <span className="font-light" data-id="element-113">
                  Lunes a Sábado
                  <br data-id="element-114" />
                  10:00 - 20:00 hrs
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal & Copyright */}
        <div className="pt-8 border-t border-mystic-gold/10 text-center" data-id="element-115">
          <p className="text-xs text-mystic-white/40 font-light max-w-3xl mx-auto mb-4 leading-relaxed" data-id="element-116">
            Los servicios ofrecidos corresponden a orientación espiritual y
            bienestar personal. No sustituyen diagnósticos médicos, psicológicos
            ni asesorías legales.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-4" data-id="element-117">
            <button onClick={onOpenPrivacy} className="text-xs text-mystic-white/60 hover:text-mystic-gold transition-colors underline-offset-4 hover:underline" data-id="element-118">
              Política de Privacidad
            </button>
            <span className="text-mystic-gold/30 text-xs hidden sm:inline" data-id="element-119">
              •
            </span>
            <button onClick={onOpenTerms} className="text-xs text-mystic-white/60 hover:text-mystic-gold transition-colors underline-offset-4 hover:underline" data-id="element-120">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-xs text-mystic-white/30" data-id="element-121">
            &copy; {new Date().getFullYear()} Maestro Navy. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}